/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUsageBasedInvoices200ResponseInvoicesInner
 */
export interface CreateUsageBasedInvoices200ResponseInvoicesInner {
    /**
     * 
     */
    spName?: string;
    /**
     * 
     */
    invoiceId?: string;
    /**
     * 
     */
    lineItems?: number;
}

/**
 * Check if a given object implements the CreateUsageBasedInvoices200ResponseInvoicesInner interface.
 */
export function instanceOfCreateUsageBasedInvoices200ResponseInvoicesInner(value: object): value is CreateUsageBasedInvoices200ResponseInvoicesInner {
    return true;
}

export function CreateUsageBasedInvoices200ResponseInvoicesInnerFromJSON(json: any): CreateUsageBasedInvoices200ResponseInvoicesInner {
    return CreateUsageBasedInvoices200ResponseInvoicesInnerFromJSONTyped(json, false);
}

export function CreateUsageBasedInvoices200ResponseInvoicesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUsageBasedInvoices200ResponseInvoicesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'spName': json['spName'] == null ? undefined : json['spName'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
        'lineItems': json['lineItems'] == null ? undefined : json['lineItems'],
    };
}

export function CreateUsageBasedInvoices200ResponseInvoicesInnerToJSON(json: any): CreateUsageBasedInvoices200ResponseInvoicesInner {
    return CreateUsageBasedInvoices200ResponseInvoicesInnerToJSONTyped(json, false);
}

export function CreateUsageBasedInvoices200ResponseInvoicesInnerToJSONTyped(value?: CreateUsageBasedInvoices200ResponseInvoicesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spName': value['spName'],
        'invoiceId': value['invoiceId'],
        'lineItems': value['lineItems'],
    };
}

